import { Injectable } from "@angular/core";
import { UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { AuthService } from "../../auth/services/auth.service";
import * as PrivacyActions from "../../privacy/state/actions/privacy.actions";

type activateReturn =
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree;
@Injectable({
  providedIn: "root",
})
export class DashboardGuard {
  constructor(
    private readonly store: Store,
    private readonly _authService: AuthService,
  ) {}

  canActivate(): activateReturn {
    if (
      !this._authService.termIsAccepted &&
      !this._authService.isLoadingTerms
    ) {
      this.store.dispatch(PrivacyActions.loadTerms());
      this._authService.isLoadingTerms = true;
    }

    return true;
  }
}
